<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="900"
      :mask-closable="false"
      title="导入客户eSIM"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form class="simiot-nested-search-form" :form="searchForm" @submit="handleSearch">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="产品名称">
              <a-input v-decorator="['name']" allow-clear placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-space>
                <a-button type="primary" html-type="submit">搜索</a-button>
                <a-button @click="handleReset">刷新</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        size="middle"
        :columns="tableColumns"
        :data-source="tableData"
        :loading="loading"
        :pagination="false"
        :scroll="{ y: 350 }"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        row-key="id"
      />

      <a-row class="count-tips">
        共 {{ tableData.length }} 条记录，已选中 {{ selectedRowKeys.length }} 条数据
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { findImportableBaseEsimProducts } from '@/api/base_esim_product'
import { importAgentsEsimProducts } from '@/api/agents_esim_product'

export default {
  name: 'ImportAgentsEsimProduct',
  props: {
    visible: { type: Boolean, required: true },
    agentId: { type: Number, required: true }
  },
  data() {
    return {
      searchForm: this.$form.createForm(this, { name: 'import_agents_esim_product_search' }),
      loading: true,
      selectedRowKeys: [],
      query: {},
      submitting: false,
      tableColumns: [
        { title: '产品名称', dataIndex: 'name' },
        { title: 'SGP规范', dataIndex: 'sgp_spec_names' }
      ],
      tableData: []
    }
  },
  computed: {
    isShow: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleSearch(e) {
      e.preventDefault()
      this.searchForm.validateFields((err, values) => {
        if (!err) {
          this.query = values
          this.selectedRowKeys = []
          this.fetchData()
        }
      })
    },
    handleReset() {
      this.searchForm.resetFields()
      this.query = {}
      this.selectedRowKeys = []
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      findImportableBaseEsimProducts(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) this.tableData = res.data
        this.loading = false
      })
    },
    handleSubmit() {
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      if (this.selectedRowKeys.length === 0) {
        this.$warning({ title: '请选择上架eSIM', content: '' })
        return
      }
      this.submitting = true
      importAgentsEsimProducts({
        agent_id: this.agentId,
        base_esim_product_ids: this.selectedRowKeys
      }).then((res) => {
        if (res.code === 0) {
          this.isShow = false
          this.$emit('completed')
        }
        this.submitting = false
      }).catch(() => { this.submitting = false })
    }
  }
}
</script>

<style scoped>
.count-tips {
  margin-top: 12px;
}
</style>
